<template>
    <div class="workSubmit">
        <div class="total">
            <div class="typeOne" v-for="(item) in typelist" :key="JSON.stringify(item)">
                {{item.qaTypeName}}
                <div class="bottom">
                    <div class="typeTow" v-for="(item2) in item.children" :key="JSON.stringify(item2)">
                        <div class="title2">{{item2.qaTypeName}}</div>
                        <div class="limit">{{item2.qaTypeDesc}}</div>
                        <el-button size="mini" @click="quest(item2)">提问</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from "plus/api";
export default {
    name:'work.submit.list',
    data() {
        return {
          typelist: []
        }
    },
    activated(){
        this.getTreeList();
    },
  deactivated() {
      this.resetData()
  },
    methods: {
      resetData(){
        this.typelist = []
      },
        getTreeList(){
            api.work.getTreeList().then(res=>{
                this.typelist = res.data.data
            })
        },
        quest(val){
          ;
            this.$router.push({name:'work.submit.write',query:{qaTypeName:val.qaTypeName,qaTypeId:val.qaTypeId}})
        }
    },
}
</script>
<style lang="less" scoped>

.total{
    .typeOne{
        color: #333333;
        font-size: 18px;
        margin-bottom: 20px;
        .bottom{
            display: flex;
            flex-wrap: wrap;
        }
        .typeTow{
            position: relative;
            text-align: center;
            margin-right: 20px;
            margin-top: 20px;
            width: 260px;
            height: 260px;
            background-color: white;
            .title2{
                margin-top: 100px;
            }
            .limit{
                padding: 0 10px;
                font-size: 14px;
                color: #999999;
            }
            /deep/.el-button{
                font-size: 16px;
                width: 80px;
                height: 36px;
                color:#FFFFFF;
                border-color: #F5A623;
                background-color: #F5A623;
                position: absolute;
                bottom: 14px;
                right: 14px;
            }
    }
    }
    .typeOne::before{
        margin-right: 8px;
        content: "";
        border-left: 4px solid #3572e2;
        height: 16px;
    }
}
</style>
